import classnames from "classnames"
import parse from "html-react-parser"

import styles from "./hello_styles.module.scss"

interface Props {
  clickAccept: () => void
  clickAcceptUrl: string
  containerStyle: string
  ctaTitle: string
  declineCopy: string
  logoCover: string
  logoHtml: string
  mainBody: string
  mainTitle: string
  onClickDecline: () => void
  onboardingStyle?: string
}

const HelloCard = ({
  clickAccept,
  clickAcceptUrl,
  containerStyle,
  ctaTitle,
  declineCopy,
  logoCover,
  logoHtml,
  mainBody,
  mainTitle,
  onClickDecline,
  onboardingStyle,
}: Props) => {
  const clickAcceptHandler = event => {
    if (clickAccept) {
      event.preventDefault()
      clickAccept()
    }
  }
  return (
    <div className={classnames(styles["popup-container"], styles[containerStyle])}>
      <div className={styles["popup-card"]}>
        <a href={clickAcceptUrl} onClick={clickAcceptHandler}>
          <div className={styles["sla-img-container"]}>
            <MainImage image={logoHtml} />
            {logoCover && <span className={styles["logo-cover"]}>{parse(logoCover)}</span>}
          </div>
          <div className={onboardingStyle ? `${styles.copy} ${styles[onboardingStyle]}` : styles.copy}>
            <h3>{mainTitle}</h3>
            <p>{mainBody}</p>
          </div>
        </a>
        <div className="action-buttons-container">
          {ctaTitle && (
            <a href={clickAcceptUrl} onClick={clickAcceptHandler} className="button-tertiary">
              {ctaTitle}
            </a>
          )}
          {declineCopy && (
            <button
              onClick={onClickDecline}
              className="button-tertiary button-cancel-link"
            >
              {declineCopy}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default HelloCard

export const MainImage = ({ image }: { image: string }) =>
  image.includes("gif") ? <img src={image} /> : <div className={styles.logo}>{parse(image)}</div>
